<template>
  <div id="qrTag" class="qr-generator">
    <vue-qr :size="500" class="qrTag" ref="qrTag" :text="qrValue"/>
    <button type="button" class="qr-generator__print" title="پرینت QR" @click="printImage()">
      <b-icon-printer/>
      <span>پرینت</span>
    </button>
  </div>
</template>

<script>
import vueQr from 'vue-qr/src/packages/vue-qr.vue'

export default {
  name: "QrGenerator",
  components: {vueQr},
  props: {
    qrValue: {
      require: true
    }
  },
  methods: {
    printImage() {
      const qrImageSrc = this.$refs.qrTag.$el.currentSrc;
      var newWindow = window.open("https://www.example.com", "_blank");
      newWindow.document.write(`<html><head><title>QR</title></head><body> <img src='${qrImageSrc}' alt='mixitweb.com'> </body></html>`);
    }
  }
}
</script>

<style>
#qrTag img {
  width: 88px;
  height: 88px;
}
.cursor-pointer{
  cursor: pointer;
}
</style>

<style scoped>
.qr-generator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.65rem;
}

.qr-generator__print {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  min-height: 36px;
  padding: 0 0.9rem;
  border: 0;
  border-radius: 999px;
  background: var(--primary, #eb3d60);
  color: #fff;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
}
</style>
